import _ from "lodash";

import User from "../interfaces/User";
import { RegisterType } from "../common/interfaces/enums/RegisterType";
import { PermissionType } from "../common/interfaces/enums/PermissionType";
import { UserType } from "../common/interfaces/enums/UserType";
import authenticationService from "../services/authenticationService";
import { Register } from "../components/RoutesConfig";

type UserContextType = {
  isAuthenticated: boolean;
  hasPermissions: (register?: Register, permissionType?: PermissionType, userTypes?: UserType[]) => boolean;
} & User;

const defaultContext: UserContextType = {
  isAuthenticated: false,
  userId: 0,
  name: "",
  userType: UserType.Notary,
  permissions: {} as Record<RegisterType, PermissionType>,
  hasPermissions: () => true,
};

export default function useUserContext() {
  const tokenUser = authenticationService.getUser();

  const isAuthenticated = tokenUser !== null;
  const user = tokenUser ?? defaultContext;

  const hasPermissions = (register?: Register, permissionType?: PermissionType, userTypes?: UserType[]) => {
    let hasPermissions = true;

    // permission by token
    if (register && permissionType) {
      // - allowed userTypes from config (is in user gropup)
      // - token permission access to current register (access to register)
      // - token permission with current register exact permission type (has read, write permission)
      hasPermissions =
        _.includes(register.Root.UserTypes, user.userType) &&
        _.has(user.permissions, register.Register) &&
        (user.permissions[register.Register] & permissionType) === permissionType;
    }

    // userType overwrite token permissions
    if (userTypes) {
      hasPermissions = _.includes(userTypes, user.userType);
    }

    // console.log(
    //   `hasPermissions: ${hasPermissions}, register: ${register}, permissionType: ${permissionType}, userTypes: ${userTypes}`
    // );

    return hasPermissions;
  };

  const isOwner = (ownerUserIds?: number[]): boolean =>
    ownerUserIds ? ownerUserIds.indexOf(user.userId) !== -1 : false;

  return { ...user, isAuthenticated, hasPermissions, isOwner };
}
